import { takeLatest, put, call } from 'redux-saga/effects'

import {
  GET_REFERRAL_MANAGEMENT_REQUESTED,
  GET_REFERRAL_MANAGEMENT_SUCCESS,
  GET_REFERRAL_MANAGEMENT_FAILURE,
} from '../constants/constant.action'
import { api } from '../services'

function* getReferralManagementSaga(action) {
  try {
    const { data } = yield call(api.getManagementReferralList, action.payload)

    if (Array.isArray(data)) {
      yield put({
        type: GET_REFERRAL_MANAGEMENT_SUCCESS,
        payload: data,
      })

      return
    }

    let hasMoreReferrals = true
    let startRange = 0
    const referrals = []

    while (hasMoreReferrals) {
      const response = yield call(api.readReferralListS3, {
        fileKey: data.fileKey,
        startRange
      })

      const { endRange } = response.data.scanRange

      hasMoreReferrals = endRange < response.data.totalObjectContentLength
      startRange = endRange

      referrals.push(...response.data.data)
    }

    yield put({
      type: GET_REFERRAL_MANAGEMENT_SUCCESS,
      payload: referrals,
    })
  } catch (error) {
    yield put({ type: GET_REFERRAL_MANAGEMENT_FAILURE, error })
  }
}

export function* referralManagementWatcherSaga() {
  yield takeLatest(GET_REFERRAL_MANAGEMENT_REQUESTED, getReferralManagementSaga)
}
